import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import PurchaseOrderOverviewTable from '../Overview/PurchaseOrderOverviewTable';
import EditContractDialog from '../Dialogs/EditContractDialog';
import { useHistory } from 'react-router-dom';

export default function OverviewPage(props) {
    const classes = useStyles();

    const { t } = useTranslation();
    const [purchaseOrders, setPurchaseOrders] = useState([])
    const [suppliers, setSuppliers] = useState([])
    const [editContractDialogOpen, setEditContractDialogOpen] = useState(false)
    const [contractIdToEdit, setContractIdToEdit] = useState(null)
    const [purchaseOrderTypes, setPurchaseOrderTypes] = useState([])
    const [freeClauses, setFreeClauses] = useState([])

    let history = useHistory();

    useEffect(() => {
        dataService.getPurchaseOrders().then((orders) => {
            let ordersFromCurrentUser = orders.Results.filter(x => x.UserIDInsert === props.authentication.userId)
            if (JSON.stringify(ordersFromCurrentUser) !== JSON.stringify(purchaseOrders)) {
                setPurchaseOrders(ordersFromCurrentUser)
            }
        }
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getSuppliers().then((supps) => {
            if (JSON.stringify(supps.Results) !== JSON.stringify(suppliers)) {
                setSuppliers(supps.Results)
            }
        }
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getPurchaseOrderTypes().then((types) => {
            if (JSON.stringify(types.Results) !== JSON.stringify(purchaseOrderTypes)) {
                setPurchaseOrderTypes(types.Results)
            }
        }
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        dataService.getFreeClauses().then((clauses) => {
            if (JSON.stringify(clauses.Results) !== JSON.stringify(freeClauses)) {
                setFreeClauses(clauses.Results)
            }
        }
        ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }, [])

    const closeDialog = () => {
        setEditContractDialogOpen(false)
    }

    const openDialog = () => {
        setEditContractDialogOpen(true)
    }

    const editContract = () => {

        let contract = purchaseOrders.find(x => x.ID === contractIdToEdit)
        props.actions.SetEditContractMode(true);
        props.actions.SetEditContractId(contractIdToEdit);
        props.actions.SetEditContractData(contract);
        let purchaseOrderLines = []
        var i
        for (i = 0; i < contract.PurchaseOrderLines.length; i++) {
            let line = contract.PurchaseOrderLines[i]
            let orderLine = {
                id:line.ID,
                fromDate: line.FromDate,
                toDate: line.ToDate,
                productID: line.ProductID,
                quantity: String(line.Quantity),
                unitOfMeasurementID: line.UnitOfMeasurementID,
                unitPrice100Kg: String(line.UnitPrice100Kg),
                contractPrice:String(line.TonPerHectContractPrice)
            }
            purchaseOrderLines.push(orderLine)
        }
        props.actions.setPurchaseOrderLines(purchaseOrderLines)

        let selectedSortedFreeClauses = []
        var i;

        for (i = 0; i < contract.FreeClauses.length; i++) {
            let freeClause = contract.FreeClauses[i]   

            let originalFreeClause = freeClauses.find(x => x.ID === freeClause.DocumentTextId)
            selectedSortedFreeClauses.push({ ID: originalFreeClause.ID, Name: originalFreeClause.Name, Index: contract.FreeClauses[i].Sequence, InformationTranslationID: originalFreeClause.InformationTranslationID, Information: originalFreeClause.Information })
        }

        let dataArea = ""
        let orderType = purchaseOrderTypes.find(x => x.ID === contract.PurchaseOrderTypeID)
        if (orderType) {
            dataArea = orderType.DataArea
        }

        props.actions.setSelectedFreeClauses(selectedSortedFreeClauses)
        props.actions.setDataArea(dataArea)
        props.actions.setHorstep(3);
        props.actions.setVertstep(13);

        history.push("/")
    }

    return (
        <div className={classes.formContainer}>
            {suppliers.length > 0 && purchaseOrders.length > 0 &&
                <PurchaseOrderOverviewTable openEditContractDialog={openDialog} purchaseOrders={purchaseOrders} suppliers={suppliers} setContractIdToEdit={setContractIdToEdit}></PurchaseOrderOverviewTable>}
            <EditContractDialog closeDialog={closeDialog} dialogOpen={editContractDialogOpen} editContract={editContract}></EditContractDialog>
        </div>
    )
}

const useStyles = makeStyles(() => ({

    formContainer: {
        width: "1000px",
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box",
        marginTop: "50px"
    }
}));